import { getErrorMessage } from "~/v2/api/hooks";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useRiskControlsButtonController } from "./RiskControlsButton.controller";
import { RiskControlsButtonPresentation } from "./RiskControlsButton.pres";
import { RiskControlsDialog } from "./RiskControlsDialog.connector";
import { useGetRiskControls } from "./useRiskControls";

export interface RiskControlsButtonProps {
  /**
   * Collapsed left rail: the row is only ~64px wide, so the button drops to the
   * two-letter form and takes the rail's row geometry.
   */
  collapsed?: boolean;
}

export const RiskControlsButton = ({ collapsed }: RiskControlsButtonProps) => {
  const { currentAccount, product } = useAccountContext();
  const accountID = currentAccount?.id;

  const {
    data,
    isLoading,
    isError,
    error: loadError,
  } = useGetRiskControls({ accountID, enabled: product === "live" });

  const { open, current, summary, openDialog, setOpen } =
    useRiskControlsButtonController({ controls: data });

  // Hidden rather than disabled: the endpoints are live-only, so on paper this
  // is a control the user can never use. Also covers the tri-state, since
  // `product` is undefined until the account lists load.
  if (product !== "live") {
    return null;
  }

  return (
    <RiskControlsButtonPresentation
      collapsed={collapsed}
      summary={summary}
      onOpen={openDialog}
      dialog={
        <RiskControlsDialog
          accountID={accountID}
          product={product}
          open={open}
          current={current}
          isLoading={isLoading}
          loadErrorMessage={
            isError
              ? getErrorMessage(loadError) ||
                "Current risk-control settings could not be loaded."
              : undefined
          }
          onOpenChange={setOpen}
        />
      }
    />
  );
};
